import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Chip, FormControl, FormControlLabel, Switch, SwitchProps, Tooltip } from '@mui/material'
import { RootState } from '../redux'
import { setAutoRefresh } from '../redux/slices/query'

/**
 * The props of the auto-refresh switch.
 */
export type DateRangeAutoRefreshSwitchProps = Omit<SwitchProps, 'value' | 'checked'>

/**
 * The auto-refresh switch.
 */
export default function DateRangeAutoRefreshSwitch({
  disabled,
  onChange,
  ...props
}: DateRangeAutoRefreshSwitchProps): React.ReactElement {
  /**
   * The translate function.
   */
  const [t] = useTranslation('common')

  /**
   * The dispatch function.
   */
  const dispatch = useDispatch()

  /**
   * Indicates if the time is kept up-to-date with the current time.
   */
  const { autoRefresh } = useSelector((state: RootState) => state.query)

  /**
   * Handle the change of the auto-refresh switch.
   */
  /**
   * Handle the change of the auto-refresh switch.
   */
  function handleChange(event: React.ChangeEvent<HTMLInputElement>, checked: boolean): void {
    dispatch(setAutoRefresh(checked))

    onChange?.(event, checked)
  }

  return (
    <FormControl size="small">
      <FormControlLabel
        control={
          <Switch
            color="error"
            size="small"
            disabled={disabled}
            {...props}
            checked={autoRefresh}
            onChange={handleChange}
          />
        }
        label={
          <>
            {autoRefresh ? (
              <Tooltip title={t('dataIsRefreshedOncePerMinue') as string}>
                <Chip
                  color="error"
                  size="small"
                  label="LIVE"
                  sx={{
                    mr: 1,
                    p: 1,
                    height: 'auto',
                    '& .MuiChip-label': { fontWeight: 700, lineHeight: '1em', px: 1 }
                  }}
                />
              </Tooltip>
            ) : (
              <Chip size="small" label="LIVE" sx={{ mr: 1 }} />
            )}
          </>
        }
        labelPlacement="start"
        sx={{ ml: 0 }}
      />
    </FormControl>
  )
}
